import axios from 'axios';
import store from '../store';
import { isRefreshRequest } from '../auth/refreshCoordinator';

export default function axiosSetUp() {
  // point to your API endpoint
  axios.defaults.baseURL = `${process.env.VUE_APP_API_ORIGIN}`;

  // Add a request interceptor
  axios.interceptors.request.use(
    function (config) {
      if (!isRefreshRequest(config.url)) {
        const token = store.getters.accessToken;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  // Add a response interceptor
  axios.interceptors.response.use(
    function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response;
    },
    async function (error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      const originalRequest = error.config;
      if (!error.response || !originalRequest) {
        return Promise.reject(error);
      }

      if (error.response.status === 401 && isRefreshRequest(originalRequest.url)) {
        return Promise.reject(error);
      }

      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          await store.dispatch('refreshToken');
          return axios(originalRequest);
        } catch (refreshError) {
          return Promise.reject(refreshError);
        }
      }
      return Promise.reject(error);
    }
  );
}
